// src/config.ts

// This file provides centralized access to environment variables
// used throughout the frontend application.

const SERVER_URL = process.env.REACT_APP_SERVER_URL as string;
const FRONTEND_URL =
  process.env.REACT_APP_FRONTEND_URL || "http://localhost:3000";

export { SERVER_URL, FRONTEND_URL };
